"use strict";
// @ts-nocheck
exports.__esModule = true;
var MARGIN = 10;
var SEPARATION_BETWEEN_HANDLERS = 26;
function getElements(parent) {
    var touchLeft = parent.querySelector(".range__filter--left");
    var touchRight = parent.querySelector(".range__filter--right");
    var lineSpan = parent.querySelector(".range__filter--line span");
    return { touchLeft: touchLeft, touchRight: touchRight, lineSpan: lineSpan };
}
function getAttributes(parent, attributes) {
    return attributes.map(function (attribute) {
        return parseFloat(parent.getAttribute(attribute));
    });
}
function getLeftStyle(_a) {
    var ratio = _a.ratio, parent = _a.parent, handler = _a.handler, isRight = _a.isRight;
    var factor = isRight ? SEPARATION_BETWEEN_HANDLERS : 0;
    return Math.ceil(ratio *
        (parent.offsetWidth -
            (handler.offsetWidth + SEPARATION_BETWEEN_HANDLERS)) +
        factor) + "px";
}
function $(selector) {
    return document.querySelector("." + selector);
}
var checkPassiveCompatibility = function () {
    try {
        var opts = Object.defineProperty({}, 'passive', {
            get: function () {
                return false;
            }
        });
        window.addEventListener("checkPassive", null, opts);
        window.removeEventListener("checkPassive", null, opts);
        return true;
    }
    catch (e) {
        return false;
    }
};
var RangeFilter = function (selector, getMinMax) {
    var startX = 0;
    var xAxis = 0;
    if (!$(selector)) {
        return;
    }
    var isPassiveSupported = checkPassiveCompatibility();
    var _a = getElements($(selector)), touchLeft = _a.touchLeft, touchRight = _a.touchRight, lineSpan = _a.lineSpan;
    var attributes = getAttributes($(selector), [
        "min",
        "max",
        "min-value",
        "max-value",
        "step"
    ]);
    var min = attributes[0], max = attributes[1], defaultAttributes = attributes.slice(2);
    var _b = defaultAttributes[0], defaultMinValue = _b === void 0 ? min : _b, _c = defaultAttributes[1], defaultMaxValue = _c === void 0 ? max : _c, _d = defaultAttributes[2], step = _d === void 0 ? 0.0 : _d;
    step = Math.abs(step);
    if (defaultMinValue < min) {
        defaultMinValue = min;
    }
    if (defaultMaxValue > max) {
        defaultMaxValue = max;
    }
    if (defaultMinValue > defaultMaxValue) {
        defaultMinValue = defaultMaxValue;
    }
    var reset = function () {
        xAxis = 0;
        startX = 0;
        touchLeft.style.left = "0px";
        lineSpan.style.marginLeft = "0px";
        lineSpan.style.width = $(selector).offsetWidth -
            touchLeft.offsetWidth + "px";
        touchRight.style.left = $(selector).offsetWidth -
            touchLeft.offsetWidth + "px";
    };
    var setValue = function (_a) {
        var typeValue = _a.typeValue, attribute = _a.attribute, isRight = _a.isRight;
        var ratio = (typeValue - min) / (max - min);
        var handleDirection = isRight ? touchRight : touchLeft;
        handleDirection.style.left = getLeftStyle({
            handler: touchLeft,
            isRight: isRight,
            parent: $(selector),
            ratio: ratio
        });
        lineSpan.style.marginLeft = touchLeft.offsetLeft + "px";
        lineSpan.style.width = touchRight.offsetLeft - touchLeft.offsetLeft + "px";
        $(selector).setAttribute(attribute, typeValue);
    };
    var setMinValue = function (minValue) {
        setValue({
            attribute: "min-value",
            typeValue: minValue
        });
    };
    var setMaxValue = function (maxValue) {
        setValue({
            attribute: "max-value",
            isRight: true,
            typeValue: maxValue
        });
    };
    reset();
    var maxX = $(selector).offsetWidth - touchRight.offsetWidth;
    var selectedTouch = null;
    var initialValue = lineSpan.offsetWidth - SEPARATION_BETWEEN_HANDLERS;
    setMinValue(defaultMinValue);
    setMaxValue(defaultMaxValue);
    function onStart(event) {
        if (event.defaultPrevented) {
            event.preventDefault();
        }
        ;
        var eventTouch = event.touches ? event.touches[0] : event;
        xAxis = this === touchLeft ? touchLeft.offsetLeft : touchRight.offsetLeft;
        startX = eventTouch.pageX - xAxis;
        selectedTouch = this;
        $(selector).addEventListener("mousemove", onMove);
        $(selector).addEventListener("mouseup", onStop);
        $(selector).addEventListener("touchmove", onMove, isPassiveSupported ? { passive: true } : false);
        $(selector).addEventListener("touchend", onStop);
        document.addEventListener("click", onStop);
    }
    var calculateValue = function () {
        var newValue = (lineSpan.offsetWidth - SEPARATION_BETWEEN_HANDLERS) / initialValue;
        var minValue = lineSpan.offsetLeft / initialValue;
        var maxValue = minValue + newValue;
        minValue = minValue * (max - min) + min;
        maxValue = maxValue * (max - min) + min;
        if (step) {
            var multi = Math.floor(minValue / step);
            minValue = step * multi;
            multi = Math.floor(maxValue / step);
            maxValue = step * multi;
        }
        if (!(minValue > maxValue)) {
            $(selector).setAttribute("min-value", minValue);
        }
        if (!(maxValue < minValue)) {
            $(selector).setAttribute("max-value", maxValue);
        }
    };
    var setxAxisLeftPosition = function () {
        if (xAxis > touchRight.offsetLeft - selectedTouch.offsetWidth + MARGIN) {
            xAxis = touchRight.offsetLeft - selectedTouch.offsetWidth + MARGIN;
        }
        if (xAxis < 0) {
            xAxis = 0;
        }
    };
    var setxAxisRightPosition = function () {
        if (xAxis < touchLeft.offsetLeft + touchLeft.offsetWidth - MARGIN) {
            xAxis = touchLeft.offsetLeft + touchLeft.offsetWidth - MARGIN;
        }
        if (xAxis > maxX) {
            xAxis = maxX;
        }
    };
    var onMove = function (event) {
        var eventTouch = event.touches ? event.touches[0] : event;
        xAxis = eventTouch.pageX - startX;
        if (selectedTouch === touchLeft) {
            setxAxisLeftPosition();
        }
        if (selectedTouch === touchRight) {
            setxAxisRightPosition();
        }
        selectedTouch.style.left = xAxis + "px";
        lineSpan.style.marginLeft = touchLeft.offsetLeft + "px";
        lineSpan.style.width = touchRight.offsetLeft - touchLeft.offsetLeft + "px";
        calculateValue();
        var _a = getAttributes($(selector), [
            "min-value",
            "max-value"
        ]), minValue = _a[0], maxValue = _a[1];
        getMinMax(minValue, maxValue);
    };
    var onStop = function () {
        document.removeEventListener("click", onStop);
        $(selector).removeEventListener("mousemove", onMove);
        $(selector).removeEventListener("mouseup", onStop);
        $(selector).removeEventListener("touchmove", onMove);
        $(selector).removeEventListener("touchend", onStop);
        selectedTouch = null;
        calculateValue();
        var _a = getAttributes($(selector), [
            "min-value",
            "max-value"
        ]), minValue = _a[0], maxValue = _a[1];
        getMinMax(minValue, maxValue);
    };
    touchLeft.addEventListener("mousedown", onStart);
    touchRight.addEventListener("mousedown", onStart);
    touchLeft.addEventListener("touchstart", onStart, isPassiveSupported ? { passive: true } : false);
    touchRight.addEventListener("touchstart", onStart, isPassiveSupported ? { passive: true } : false);
};
exports["default"] = RangeFilter;
